// Module
var code = " <gh-dialog layout=\"catalog\"> <gh-dialog-header title=\"{{'lbl_result_message' | translate}}\"></gh-dialog-header> <gh-dialog-content class=\"form m-log-message text-small text-secondary overflow-y-auto\" align=\"top\">{{ text }}</gh-dialog-content> </gh-dialog>";
// Exports
module.exports = code;